<template>
	<div>
		<v-layout row justify-center>
			<v-dialog
				:value="true"
				scrollable
				fullscreen
				hide-overlay>
				<div v-shortkey="['esc']" @shortkey="$emit('close')"></div>
				<v-card color="background">
					<v-card-title class="pa-0 primary">
						<v-spacer></v-spacer>
						<span class="title color--text">
							{{ toolbarTitle }}
						</span>
						<v-spacer></v-spacer>
						<TicketForm></TicketForm>
						<v-btn large icon class="m-1 color--text" @click="$emit('close')">
							<v-icon large>close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text class="pa-0">
						<Explorer
							:multiselect="multiselect"
							:no_select="no_select"
							:assetType="assetType"
							:shortcuts="shortcuts"
							:default_folder="default_folder"
							:return_dir_filelist="return_dir_filelist"
							:no_previous_path="no_previous_path"
							@asset-selected="$emit('selectedAssets', $event);$emit('close')">
						</Explorer>
					</v-card-text>
				</v-card>
			</v-dialog>
		</v-layout>

	</div>
</template>

<script>
import Explorer from '@/pages/filesystem/explorer.vue'
import TicketForm from '@/pages/about/ticket_form.vue'
export default {
	props: [
		'shortcuts',
		'assetType',
		'multiselect',
		'toolbarTitle',
		'default_folder',
		'no_select',
		'return_dir_filelist',
		'no_previous_path'
	],
	name: 'explorer_modal',
	components: { Explorer, TicketForm }
}
</script>

<style scoped lang="stylus">
.v-card__title
	max-height: 48px
</style>



// WEBPACK FOOTER //
// src/components/modal_explorer.vue